import CommentInputBox from './CommentInputBox.container';

export default CommentInputBox;
